var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-navigation",class:{ active: _vm.isActive }},[_c('router-link',{attrs:{"to":_vm.to}},[_c('div',[_vm._v(_vm._s(_vm.title))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }